import DataTable, { type DataTableColumn } from '../components/DataTable';
import LineChart from '../components/LineChart';
import MetricCard from '../components/MetricCard';
import PageHeader from '../components/PageHeader';
import SectionCard from '../components/SectionCard';
import { StatusBadgeFor } from '../components/StatusBadge';
import {
  attendanceStats,
  dailyAttendanceCounts,
  thisWeekAttendance
} from '../data/mockHelpers';
import type { AttendanceRecord } from '../data/mock';
import DashboardLayout from '../components/DashboardLayout';
import { dashboardSidebar, dashboardUser, type BusinessPageProps } from './dashboardSidebar';

const attendanceColumns: DataTableColumn<AttendanceRecord>[] = [
  { key: 'employeeId', header: '员工', cell: (r) => r.employeeId },
  { key: 'date', header: '日期', cell: (r) => r.date },
  { key: 'checkIn', header: '上班打卡', cell: (r) => r.checkIn || '—', align: 'center' },
  { key: 'checkOut', header: '下班打卡', cell: (r) => r.checkOut || '—', align: 'center' },
  {
    key: 'status',
    header: '状态',
    cell: (r) => StatusBadgeFor({ status: r.status })
  }
];

function AttendancePage(props: BusinessPageProps) {
  const rows = thisWeekAttendance();
  const stats = attendanceStats();
  const daily = dailyAttendanceCounts();

  return (
    <DashboardLayout
      sidebar={dashboardSidebar}
      user={dashboardUser}
      pageTitle={{ heading: '考勤管理', sub: '' }}
      metrics={[]}
      chart={{ title: '', data: [], xLabels: [] }}
      quickAccess={[]}
      activeSidebarId="attendance"
      omitPageTitle
      settingsPanel={props.settingsPanel}
      mobileMenu={props.mobileMenu}
      sidebarOpen={props.sidebarOpen}
    >
      <PageHeader
        heading="考勤管理"
        sub={`本周 ${rows.length} 条打卡记录`}
        actions={
          <>
            <button type="button">导出</button>
            <button type="button" className="is-primary">补卡</button>
          </>
        }
      />
      <div className="axi-section">
        <div className="axi-metric-grid">
          <MetricCard label="应到" value={String(stats.expected)} unit="次" icon="users" />
          <MetricCard label="实到" value={String(stats.actual)} unit="次" icon="check" />
          <MetricCard label="迟到" value={String(stats.late)} unit="次" icon="clock" neutral />
          <MetricCard label="请假" value={String(stats.leave)} unit="次" icon="document" neutral />
        </div>
      </div>
      <SectionCard title="本周考勤趋势" description="按日聚合 · 数值越高代表正常打卡人数越多">
        <LineChart
          title="每日正常打卡"
          data={daily.map((d) => d.count * 20 + 30)}
          xLabels={daily.map((d) => d.label)}
          yMax={250}
        />
      </SectionCard>
      <SectionCard title="打卡明细" description="本周所有考勤记录">
        <DataTable<AttendanceRecord>
          columns={attendanceColumns}
          rows={rows}
          rowKey={(r) => r.id}
        />
      </SectionCard>
    </DashboardLayout>
  );
}

export default AttendancePage;